module.exports = __webpack_public_path__ + "img/signed-feedback-icon.4b6926f4.svg";